import {
  AppCard,
  Icon,
  PageContainer,
  RouteButtonLink,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiPlus } from "@mdi/js";
import { Box, CircularProgress } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { ForbiddenError } from "../../../../errors/ForbiddenError";
import { useAuth } from "../../../../hooks/useAuth";
import { VendorsFilters } from "./-internal_components/VendorsFilters";
import { VendorsTable } from "./-internal_components/VendorsTable";
import { searchSchema } from "./-schemas/searchSchema";

const RouteComponent: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <PageContainer maxWidth="xl" title={t("common.vendors")}>
      <AppCard>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Suspense
            fallback={
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress size={24} sx={{ margin: 2 }} />
              </Box>
            }
          >
            <VendorsFilters />
          </Suspense>
          {user?.roles_names.includes(
            "Vsupplierregistration - Create Vendor",
          ) && (
            <RouteButtonLink
              startIcon={<Icon icon={mdiPlus} />}
              to="/vsupplierregistration/vendors/new_by_equinor"
            >
              {t("common.newVendor")}
            </RouteButtonLink>
          )}
        </Box>

        <Suspense
          fallback={
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress size={24} sx={{ margin: 2 }} />
            </Box>
          }
        >
          <VendorsTable />
        </Suspense>
      </AppCard>
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/vendors/",
  // biome-ignore assist/source/useSortedKeys: ordering required for type inference, waiting a TanStack Biome plugin
)({
  validateSearch: searchSchema,
  component: RouteComponent,
  loaderDeps: ({ search }) => ({
    filters: {
      country: search.country,
      name: search.name,
      sap_code: search.sapCode,
      segment: search.segment,
      tax_number: search.taxNumber,
    },
    items_per_page: search.itemsPerPage,
    orders: {
      "order[country]": search.order.country,
      "order[fullvendorname]": search.order.fullvendorname,
      "order[sap_code]": search.order.sap_code,
      "order[segment]": search.order.segment,
      "order[segment2]": search.order.segment2,
      "order[taxnumber1]": search.order.taxnumber1,
    },
    page: search.page,
  }),
  beforeLoad({ context }) {
    if (
      context.auth.user?.roles_names.includes("View All Vendors") ||
      context.auth.user?.roles_names.includes("Edit All Vendors")
    ) {
      return;
    }

    throw new ForbiddenError();
  },
});
